import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  acao: "bloquear" | "desbloquear";
}

export function ModalCertezaAcaoVeiculo({
  show,
  handleClose,
  onConfirm,
  acao,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Editar veículo"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Salvar"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Deseja confirmar o {acao == "bloquear" ? "bloqueio" : "desbloqueio"} dos
        veículos listados no lote?
      </ModalBody>
    </ModalCustom>
  );
}
